import { CrudService } from "../services/crud.service";
import { message } from "../shared/message";

const initialState = {
  resource: "",
  resourceName: "",
  user: {
    data: {},
    item: {}
  },
  role: {
    data: {},
    item: {}
  },
  menu: {
    data: {},
    item: {},
    all: []
  },
  wblCategory: {
    data: {},
    item: {},
    all: {}
  },
  wbl: {
    data: {},
    item: {}
  },
  collectionTable: {
    data: {},
    item: {},
    collectionColumns: [],
    all: []
  },
  // collectionColumn: {
  //   data: {},
  //   item: {},
  //   all: []
  // },
  dashboardTemplate: {
    data: {},
    item: {},
    dashboardItems: [],
    searchItems: [],
    activeTab: 0
  },
  dashboardWidget: {
    data: {},
    item: {},
    dashboardTemplates: []
  },
  evidenceVestiges: {
    data: {},
    item: {}
  },
  
};

export const crud = {
  namespaced: true,
  state: initialState,
  actions: {
    getItemList({ commit, state, rootState }, searchPayload) {
      let rcName = (searchPayload && searchPayload.resource) ? searchPayload.resource : state.resource;
      let pagination = (searchPayload && searchPayload.pagination) ? searchPayload.pagination : rootState.common.pagination;
      let searchQuery = (searchPayload && searchPayload.searchQuery) ? searchPayload.searchQuery : rootState.common.searchQuery;

      return CrudService.of(rcName)
        .getList(pagination, searchQuery)
        .then(data => {
          if (data != undefined) {
            commit("loadItemList", data);
            commit("common/setTotalItems", data.totalElements, { root: true });
          } else {
            commit("loadItemList", {});
            commit("common/setTotalItems", 0, { root: true });
          }
          return data;
        });
    },
    getAll({ commit, state }) {
      return CrudService.of(state.resource).getAll().then(data => {
        commit("loadAll", data);
        return data;
      });
    },
    getItem({ commit, state }, id) {
      return CrudService.of(state.resource).getItem(id).then(item => {
           commit("loadItem", item);
           return item;
      });
    },

    createItem({ state }, item) {
      return CrudService.of(state.resource).createItem(item).then(() => {
          message.success(`Create ${state.resource} Success!`, `/${state.resource}`)
          return item;
      });
    },
    updateItem({ state }, item) {
      return CrudService.of(state.resource).updateItem(item).then(() => {
          message.success(`Update ${state.resource} Success!`, `/${state.resource}`)
          return item;
      });
    },
    deleteItem({ state, dispatch }, id) {
      return CrudService.of(state.resource).deleteItem(id).then(() => {
          message.success(`Delete ${state.resource} Success!`);
          dispatch("getItemList");
          return id;
      });
    },
    deleteItemList({ state, dispatch }, ids) {
      return CrudService.of(state.resource).deleteItemList(ids).then(() => {
          message.success(`Delete ${state.resource} Success!`);
          dispatch("getItemList");
          return ids;
      });
    },
    downloadExcel({ commit, state, rootState }, excelPayload){
      let rcName = (excelPayload && excelPayload.resource) ? excelPayload.resource : state.resource;
      let pagination = (excelPayload && excelPayload.pagination) ? excelPayload.pagination : rootState.common.pagination;
      let searchQuery = (excelPayload && excelPayload.searchQuery) ? excelPayload.searchQuery : rootState.common.searchQuery;

      return CrudService.of(rcName).downloadExcel(pagination, searchQuery).then(data => {
        console.log(data);
        return data;
      });
    }

  },
  mutations: {
    setResource(state, name){
      var camelCased = name.replace(/-([a-z])/g, function(g) {
        return g[1].toUpperCase();
      });
      state.resource = name;
      state.resourceName = camelCased;
    },
    loadItemList(state, data) {
      state[state.resourceName].data = data;
    },
    loadAll(state, data) {
      state[state.resourceName].all = data;
    },
    loadItem(state, item) {
      state[state.resourceName].item = item;
    },
    loadRcData(state, rcdata) {
      state[state.resourceName][rcdata.key] = rcdata.data;
    }

  }
};
